import { ResourceType } from '../enumerations/ResourceType';
import { useProjectActions } from '../resources/artifacts/project/projectResource';
import { useSystemAnnouncementActions } from '../resources/persistables/system/announcement/systemAnnouncementResource';
import {
    useSystemAnnouncementUserDismissalActions,
} from '../resources/persistables/system/announcement/systemAnnouncementUserDismissalResource';
import { useSystemSettingsActions } from '../resources/persistables/system/settings/systemSettingsResource';
import { useProjectUserGroupActions } from '../resources/persistables/user/projectUserGroupResource';
import {
    useProjectUserGroupRoleAssignmentActions,
} from '../resources/persistables/user/projectUserGroupRoleAssignmentResource';
import { useProjectUserRoleActions } from '../resources/persistables/user/projectUserRoleResource';
import { useSystemUserGroupActions } from '../resources/persistables/user/systemUserGroupResource';
import {
    useSystemUserGroupRoleAssignmentActions,
} from '../resources/persistables/user/systemUserGroupRoleAssignmentResource';
import { useSystemUserRoleActions } from '../resources/persistables/user/systemUserRole';
import { useUserActions } from '../resources/persistables/user/userResource';
import { useActivitiesActions } from '../resources/artifacts/activities/activitiesResource';
import { useContentActions } from '../resources/artifacts/content/contentResource';
import { useActivitiesModelActions } from '../resources/artifacts/activities/activitiesModelResource';
import { useCriteriaActions } from '../resources/artifacts/criteria/criteriaResource';
import { useMethodActions } from '../resources/artifacts/method/methodResource';
import { useContentSectionActions } from '../resources/artifacts/content/contentSectionResource';
import { useContentSectionContentActions } from '../resources/artifacts/content/contentSectionContentResource';
import { useImageAttachmentActions } from '../resources/artifacts/attachment/imageAttachmentResource';
import { useObjectiveActions } from '../resources/artifacts/objective/objectiveResource';
import { useProcessAreaActions } from '../resources/artifacts/process_area/processAreaResource';
import {
    useProcessAreaActivityAssociationActions,
} from '../resources/artifacts/process_area/processAreaActivityAssociationResource';
import {
    useProcessAreaCriteriaAssociationActions,
} from '../resources/artifacts/process_area/processAreaCriteriaAssociationResource';
import {
    useProcessAreaMethodAssociationActions,
} from '../resources/artifacts/process_area/processAreaMethodAssociationResource';
import {
    useProcessAreaObjectiveAssociationActions,
} from '../resources/artifacts/process_area/processAreaObjectiveAssociationResource';
import {
    useProcessAreaProcessArtifactAssociationActions,
} from '../resources/artifacts/process_area/processAreaProcessArtifactAssociationResource';
import {
    useProcessAreaRoleAssociationActions,
} from '../resources/artifacts/process_area/processAreaRoleAssociationResource';
import { useProcessAreaRoleRelationActions } from '../resources/artifacts/role/processAreaRoleRelationResource';
import {
    useProcessAreaToolAssociationActions,
} from '../resources/artifacts/process_area/processAreaToolAssociationResource';
import {
    useProcessAreaVerificationMetricAssociationActions,
} from '../resources/artifacts/process_area/processAreaVerificationMetricAssociationResource';
import { useProcessArtifactActions } from '../resources/artifacts/process_artifact/processArtifactResource';
import { useProjectVersionActions } from '../resources/artifacts/project/projectVersionResource';
import { useProjectVersionPublishmentActions } from '../resources/artifacts/project/projectVersionPublishmentResource';
import { useRoleActions } from '../resources/artifacts/role/roleResource';
import { useStandardActions } from '../resources/artifacts/standard/standardResource';
import { useToolActions } from '../resources/artifacts/tool/toolResource';
import { useUseCaseActions } from '../resources/artifacts/use_case/useCaseResource';
import {
    useUseCaseStandardAssociationActions,
} from '../resources/artifacts/use_case/useCaseStandardAssociationResource';
import {
    useUseCaseWorkflowAssociationRepresentationActions,
} from '../resources/artifacts/use_case/useCaseWorkflowRepresentationAssociationResource';
import { useVCycleElementActions } from '../resources/artifacts/use_case/representation/vcycleElementResource';
import {
    useVCycleElementContainerActions,
} from '../resources/artifacts/use_case/representation/vcycleElementContainerResource';
import {
    useVCycleElementContainerFilterActions,
} from '../resources/persistables/user/vcycleElementContainerFilterResource';
import {
    useVCycleElementDecoratorActions,
} from '../resources/artifacts/use_case/representation/vcycleElementDecoratorResource';
import { useVerificationMetricActions } from '../resources/artifacts/verification_metric/verificationMetricResource';
import { useVideoAttachmentActions } from '../resources/artifacts/attachment/videoAttachmentResource';
import { useVideoAttachmentContentActions } from '../resources/artifacts/attachment/videoAttachmentContentResource';
import {
    useWorkflowRepresentationActions,
} from '../resources/artifacts/use_case/representation/workflowRepresentationResource';
import { useGridElementActions } from '../resources/artifacts/use_case/representation/gridElementResource';
import {
    useGridElementDecoratorActions
} from '../resources/artifacts/use_case/representation/gridElementDecoratorResource';

const resourceTypeToAdapter = {
    [ResourceType.ACTIVITIES]: useActivitiesActions,
    [ResourceType.ACTIVITIES_MODEL]: useActivitiesModelActions,
    [ResourceType.CONTENT]: useContentActions,
    [ResourceType.CONTENT_SECTION]: useContentSectionActions,
    [ResourceType.CONTENT_SECTION_CONTENT]: useContentSectionContentActions,
    [ResourceType.CRITERIA]: useCriteriaActions,
    [ResourceType.IMAGE_ATTACHMENT]: useImageAttachmentActions,
    [ResourceType.METHOD]: useMethodActions,
    [ResourceType.NONE]: undefined,
    [ResourceType.OBJECTIVE]: useObjectiveActions,
    [ResourceType.PROCESS_AREA]: useProcessAreaActions,
    [ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION]: useProcessAreaActivityAssociationActions,
    [ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION]: useProcessAreaCriteriaAssociationActions,
    [ResourceType.PROCESS_AREA_METHOD_ASSOCIATION]: useProcessAreaMethodAssociationActions,
    [ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION]: useProcessAreaObjectiveAssociationActions,
    [ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION]: useProcessAreaProcessArtifactAssociationActions,
    [ResourceType.PROCESS_AREA_ROLE_ASSOCIATION]: useProcessAreaRoleAssociationActions,
    [ResourceType.PROCESS_AREA_ROLE_RELATION]: useProcessAreaRoleRelationActions,
    [ResourceType.PROCESS_AREA_TOOL_ASSOCIATION]: useProcessAreaToolAssociationActions,
    [ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION]: useProcessAreaVerificationMetricAssociationActions,
    [ResourceType.PROCESS_ARTIFACT]: useProcessArtifactActions,
    [ResourceType.PROJECT]: useProjectActions,
    [ResourceType.PROJECT_USER_GROUP]: useProjectUserGroupActions,
    [ResourceType.PROJECT_USER_GROUP_ROLE_ASSIGNMENT]: useProjectUserGroupRoleAssignmentActions,
    [ResourceType.PROJECT_USER_ROLE]: useProjectUserRoleActions,
    [ResourceType.PROJECT_VERSION]: useProjectVersionActions,
    [ResourceType.PROJECT_VERSION_PUBLISHMENT]: useProjectVersionPublishmentActions,
    [ResourceType.ROLE]: useRoleActions,
    [ResourceType.STANDARD]: useStandardActions,
    [ResourceType.SYSTEM_ANNOUNCEMENT]: useSystemAnnouncementActions,
    [ResourceType.SYSTEM_ANNOUNCEMENT_USER_DISMISSAL]: useSystemAnnouncementUserDismissalActions,
    [ResourceType.SYSTEM_SETTINGS]: useSystemSettingsActions,
    [ResourceType.SYSTEM_USER_GROUP]: useSystemUserGroupActions,
    [ResourceType.SYSTEM_USER_GROUP_ROLE_ASSIGNMENT]: useSystemUserGroupRoleAssignmentActions,
    [ResourceType.SYSTEM_USER_ROLE]: useSystemUserRoleActions,
    [ResourceType.TOOL]: useToolActions,
    [ResourceType.USER]: useUserActions,
    [ResourceType.USE_CASE]: useUseCaseActions,
    [ResourceType.USE_CASE_STANDARD_ASSOCIATION]: useUseCaseStandardAssociationActions,
    [ResourceType.USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION]: useUseCaseWorkflowAssociationRepresentationActions,
    [ResourceType.VERIFICATION_METRIC]: useVerificationMetricActions,
    [ResourceType.VIDEO_ATTACHMENT]: useVideoAttachmentActions,
    [ResourceType.VIDEO_ATTACHMENT_CONTENT]: useVideoAttachmentContentActions,
    [ResourceType.GRID_ELEMENT]: useGridElementActions,
    [ResourceType.GRID_ELEMENT_DECORATOR]: useGridElementDecoratorActions,
    [ResourceType.V_CYCLE_ELEMENT]: useVCycleElementActions,
    [ResourceType.V_CYCLE_ELEMENT_CONTAINER]: useVCycleElementContainerActions,
    [ResourceType.V_CYCLE_ELEMENT_CONTAINER_FILTER]: useVCycleElementContainerFilterActions,
    [ResourceType.V_CYCLE_ELEMENT_DECORATOR]: useVCycleElementDecoratorActions,
    [ResourceType.WORKFLOW_REPRESENTATION]: useWorkflowRepresentationActions,
} as const satisfies Record<ResourceType, unknown>;

export const getUseActionsByResourceType = <RT extends ResourceType>(resourceType: RT) => {
    const result = resourceTypeToAdapter[resourceType];

    if (!result) {
        throw Error(`No adapter exists for ResourceType ${resourceType}!`);
    }

    return result;
};
